module.exports = __webpack_public_path__ + "img/LogoText_Lang.0f6fff87.png";